import { useContext, useEffect, useState } from "react";
import convertNumbersToPersian from "../../../Utils/convertNumbersToPersian";
import { TimerContext } from "../../../Context/TimerContext";

const ReadingTime = ({ Styles, loading }) => {
  const [showRestTime, setShowRestTime] = useState(false);
  const [restTimeCounter, setRestTimeCounter] = useState(5 * 60);
  const [showRestModal, setShowRestModal] = useState(false);
  const [readingCounter, setReadingCounter] = useState(25 * 60);
  const { changeShowTimer } = useContext(TimerContext);

  useEffect(() => {
    if (readingCounter > 0) {
      if (!loading) {
        const timerInterval = setInterval(() => {
          setReadingCounter((prevTime) => prevTime - 1);
          changeShowTimer(readingCounter - 1);
        }, 1000);

        return () => clearInterval(timerInterval);
      }
    } else if (!showRestTime && !showRestModal) {
      setShowRestModal(true);
    }
  }, [readingCounter, showRestModal, showRestTime, changeShowTimer, loading]);

  useEffect(() => {
    if (showRestTime && restTimeCounter !== 0) {
      const restInterval = setInterval(() => {
        setRestTimeCounter((prevTime) => prevTime - 1);
      }, 1000);

      return () => {
        clearInterval(restInterval);
      };
    } else if (restTimeCounter === 0) {
      setShowRestTime(false);
      setRestTimeCounter(0);
      setReadingCounter(25 * 60);
    }
  }, [showRestTime, restTimeCounter]);
  //* time formatter
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;

    // تبدیل اعداد انگلیسی به اعداد فارسی
    const persianMinutes = convertNumbersToPersian(minutes.toString());
    const persianSeconds = convertNumbersToPersian(
      seconds < 10 ? "0" + seconds : seconds.toString()
    );

    return `${persianMinutes}:${persianSeconds}`;
  };
  return (
    <>
      {showRestTime && (
        <div className={Styles.timerContainer}>
          <h2>
            زمان باقی مانده تا ادامه مطالعه : {formatTime(restTimeCounter)}
          </h2>
        </div>
      )}

      {showRestModal && (
        <div className={Styles.modal}>
          <p>آیا می‌خواهید استراحت کنید؟</p>
          <div className={Styles.buttons}>
            <button
              onClick={() => {
                setShowRestModal(false);
                setReadingCounter(25 * 60);
              }}
            >
              خیر
            </button>
            <button
              onClick={() => {
                setShowRestTime(true);
                setShowRestModal(false);
              }}
            >
              بله
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ReadingTime;
